import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { useFiltersI18n } from '../../filters-i18n-provider';
import { useFiltersTheme } from '../../filters-theme-provider';

export type MoreLessButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  expanded: boolean;
};

export const MoreLessButton = forwardRef<
  HTMLButtonElement,
  MoreLessButtonProps
>(({ onClick, expanded, ...forwardingProps }, forwardingRef) => {
  const { accentColor } = useFiltersTheme();
  const { t } = useFiltersI18n();

  return (
    <Button
      {...forwardingProps}
      $accentColor={accentColor}
      onClick={onClick}
      ref={forwardingRef}
    >
      {expanded ? t('Show Less') : t('Show More')}
    </Button>
  );
});

const Button = styled.button.attrs({
  className: createReadableClass({
    component: 'more-less-button',
    element: 'button'
  })
})<{
  $accentColor: string;
}>`
  cursor: pointer;
  display: inline-flex;
  align-self: flex-start;
  gap: 4px;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  border-radius: 8px;
  border: none;
  padding: 0;
  background: none;
  transition: text-decoration 0.2s ease;

  ${({ $accentColor }) => css`
    color: ${$accentColor};
  `}

  &:hover {
    text-decoration: underline;
  }
`;
